import React, { useEffect, useState } from "react";
import api from "../lib/api";
import VehicleCard from "../components/VehicleCard";

const LatestArrivals = () => {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/vehicles?sort=latest&limit=48").then((r) => { setVehicles(r.data); setLoading(false); });
  }, []);
  return (
    <div className="container-wide py-16" data-testid="page-latest-arrivals">
      <div className="border-b hairline pb-8 mb-10">
        <div className="overline text-[#7A1519] mb-3">Latest Arrivals</div>
        <h1 className="font-display text-4xl md:text-6xl tracking-tighter text-[#111111] font-semibold leading-tight">Fresh onto the floor</h1>
        <p className="mt-6 max-w-2xl text-[#242424]/70">The newest additions to the Autobahn showroom, ordered by arrival date.</p>
      </div>
      {loading ? (
        <div className="text-sm text-[#242424]/60">Loading…</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {vehicles.map((v) => <VehicleCard key={v.id} vehicle={v} testIdPrefix="latest" />)}
        </div>
      )}
    </div>
  );
};

export default LatestArrivals;
